const environment = process.env.REACT_APP_ENVIROMENT;

console.log('printing enviroment variable >>>>', environment);
let API_URL = 'http://localhost:3001/api/v1';

if (environment === 'DEV') {
  API_URL = 'http://localhost:3001/api/v1';
} else if (environment === 'PROD') {
  API_URL = `${window.location.protocol}//ttn-unsubscribe-svc.tothenew.com/api/v1`;
}

export {
  API_URL,
};
